<template lang="html">
	<div
		v-show="realLaunch"
		class="modal-container row"
		:class="{activated: launch}"
		@click="closeFromOutside">
		<div class="modal-content" @click.stop>
			<component v-if="show" :data="data" :is="content" @close="close"/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'baseModal',
	props: ['show', 'content', 'data', 'disableClickOutside'],
	data () {
		return {
			launch: false,
			realLaunch: false
		}
	},
	mounted () {
		if (this.show) {
			this.launch = true
			this.realLaunch = true
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		closeFromOutside () {
			if (!(this.disableClickOutside)) {
				this.close();
			}
		}
	},
	watch: {
		show (value) {
			if (value) {
				this.realLaunch = true
				window.setTimeout(() => { this.launch = true }, 10)
			} else {
				window.setTimeout(() => { this.launch = false }, 10)
				window.setTimeout(() => { this.realLaunch = false }, 510)
			}
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// baseModal.vue?0b868818